<template>
  <ViewTopNav :heading="this.viewType" :subheading="this.assetType" />

  <div class="position-absolute p-content z-1">
    <div class="row g-0 h-100">
      <div class="col-12" v-if="viewType.includes('renders')">
        <div
          id="rendersCarousel"
          class="carousel slide"
          data-bs-ride="carousel"
        >
          <div class="carousel-indicators">
            <button
              v-for="(asset, index) in assetTypes"
              :key="asset.guid"
              type="button"
              :data-bs-target="'#rendersCarousel'"
              :data-bs-slide-to="index"
              :class="{ active: index === 0 }"
              aria-current="index === 0 ? 'true' : 'false'"
              :aria-label="'Slide ' + (index + 1)"
            ></button>
          </div>
          <div class="carousel-inner">
            <div
              v-for="(asset, index) in assetTypes"
              :key="asset.guid"
              :class="['carousel-item', { active: index === 0 }]"
            >
              <img
                :src="
                  theme.cdnUrl +
                  '/assets/' +
                  this.assetType +
                  '/' +
                  this.viewType +
                  '/' +
                  asset.LinkName +
                  '?width=700'
                "
                class="d-block w-100 img-fluid"
                style="height: 90vh; object-fit: contain"
                :alt="asset.title"
              />
              <div class="carousel-caption d-none d-md-block">
                <h5>{{ asset.title }}</h5>
              </div>
            </div>
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#rendersCarousel"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#rendersCarousel"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ViewBotNav />
  <OffCanvas />
</template>

<script>
import ViewTopNav from "@/components/ViewTopNav.vue";
import ViewBotNav from "@/components/ViewBotNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";

export default {
  name: "AssetView",
  props: ["assetType", "viewType", "lid", "collectionId"],
  components: {
    ViewTopNav,
    ViewBotNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      folderStructure: encodeURIComponent(
        this.theme.devFolder +
          "/assets/" +
          this.assetType +
          "/" +
          this.viewType +
          "/"
      ),
      videoStatus: false,
      assetNames: null,
      assetUrls: null,
    };
  },
  created() {
    if (this.assetType === "masterplan") {
      if (this.viewType === "masterplan-flythrough") {
        this.assetOrder = this.theme.masterplanAsset.videos;
        this.assetNames = this.theme.masterplanAsset.videosName;
      } else if (this.viewType === "masterplan-360-tour") {
        this.assetOrder = this.theme.masterplanAsset.panoramas;
        this.assetNames = this.theme.masterplanAsset.panoramasName;
        this.assetUrls = this.theme.masterplanAsset.panoramasUrl;
      } else if (this.viewType === "masterplan-renders") {
        this.assetOrder = this.theme.masterplanAsset.renders;
        this.assetNames = this.theme.masterplanAsset.renders;
        this.assetUrls = this.theme.masterplanAsset.renders;
      }
    } else if (this.assetType === "amenity") {
      if (this.viewType === "infinity-terrace-flythrough") {
        this.assetOrder = this.theme.amenityAsset.videos;
        this.assetNames = this.theme.amenityAsset.videosName;
      } else if (this.viewType === "infinity-terrace-360-tour") {
        this.assetOrder = this.theme.amenityAsset.panoramas;
        this.assetNames = this.theme.amenityAsset.panoramasName;
        this.assetUrls = this.theme.amenityAsset.panoramasUrl;
      } else if (this.viewType === "infinity-terrace-renders") {
        this.assetOrder = this.theme.amenityAsset.renders;
        this.assetNames = this.theme.amenityAsset.renders;
        this.assetUrls = this.theme.amenityAsset.renders;
      }
    } else if (this.assetType === "skyline-design-3-bedroom") {
      if (this.viewType === "skyline-flythrough") {
        this.assetOrder = this.theme.skylineAsset.videos;
        this.assetNames = this.theme.skylineAsset.videosName;
      } else if (this.viewType === "skyline-360-tour") {
        this.assetOrder = this.theme.skylineAsset.panoramas;
        this.assetNames = this.theme.skylineAsset.panoramasName;
        this.assetUrls = this.theme.skylineAsset.panoramasUrl;
      } else if (this.viewType === "skyline-renders") {
        this.assetOrder = this.theme.skylineAsset.renders;
        this.assetNames = this.theme.skylineAsset.renders;
        this.assetUrls = this.theme.skylineAsset.renders;
      }
    } else if (this.assetType === "canopy-design-4-bedroom") {
      if (this.viewType === "canopy-flythrough") {
        this.assetOrder = this.theme.canopyAsset.videos;
        this.assetNames = this.theme.canopyAsset.videosName;
      } else if (this.viewType === "canopy-360-tour") {
        this.assetOrder = this.theme.canopyAsset.panoramas;
        this.assetNames = this.theme.canopyAsset.panoramasName;
        this.assetUrls = this.theme.canopyAsset.panoramasUrl;
      } else if (this.viewType === "canopy-renders") {
        this.assetOrder = this.theme.canopyAsset.renders;
        this.assetNames = this.theme.canopyAsset.renders;
        this.assetUrls = this.theme.canopyAsset.renders;
      }
    } else if (this.assetType === "savanna-design-4-bedroom") {
      if (this.viewType === "savanna-flythrough") {
        this.assetOrder = this.theme.savannaAsset.videos;
        this.assetNames = this.theme.savannaAsset.videosName;
      } else if (this.viewType === "savanna-360-tour") {
        this.assetOrder = this.theme.savannaAsset.panoramas;
        this.assetNames = this.theme.savannaAsset.panoramasName;
        this.assetUrls = this.theme.savannaAsset.panoramasUrl;
      } else if (this.viewType === "savanna-renders") {
        this.assetOrder = this.theme.savannaAsset.renders;
        this.assetNames = this.theme.savannaAsset.renders;
        this.assetUrls = this.theme.savannaAsset.renders;
      }
    } else if (this.assetType === "broadview-design-4-bedroom") {
      if (this.viewType === "broadview-flythrough") {
        this.assetOrder = this.theme.broadviewAsset.videos;
        this.assetNames = this.theme.broadviewAsset.videosName;
      } else if (this.viewType === "broadview-360-tour") {
        this.assetOrder = this.theme.broadviewAsset.panoramas;
        this.assetNames = this.theme.broadviewAsset.panoramasName;
        this.assetUrls = this.theme.broadviewAsset.panoramasUrl;
      } else if (this.viewType === "broadview-renders") {
        this.assetOrder = this.theme.broadviewAsset.renders;
        this.assetNames = this.theme.broadviewAsset.renders;
        this.assetUrls = this.theme.broadviewAsset.renders;
      }
    } else if (this.assetType === "hinterland-design-4-bedroom") {
      if (this.viewType === "hinterland-flythrough") {
        this.assetOrder = this.theme.hinterlandAsset.videos;
        this.assetNames = this.theme.hinterlandAsset.videosName;
      } else if (this.viewType === "hinterland-360-tour") {
        this.assetOrder = this.theme.hinterlandAsset.panoramas;
        this.assetNames = this.theme.hinterlandAsset.panoramasName;
        this.assetUrls = this.theme.hinterlandAsset.panoramasUrl;
      } else if (this.viewType === "hinterland-renders") {
        this.assetOrder = this.theme.hinterlandAsset.renders;
        this.assetNames = this.theme.hinterlandAsset.renders;
        this.assetUrls = this.theme.hinterlandAsset.renders;
      }
    }

    // Video type
    if (this.viewType === "videos") {
      BunnyNetService.getVideos(this.lid, this.collectionId)
        .then((response) => {
          // Remap array (inject asset names)
          let j = 0;
          const menuItems = response.data.items.map((item) => {
            return {
              guid: item.guid,
              videoLibraryId: item.videoLibraryId,
              thumbnailFileName: item.thumbnailFileName,
              ObjectName: item.ObjectName,
              title: this.assetNames[j],
              id: j++,
            };
          });

          // Custom order array
          this.assetTypes = menuItems;

          this.videoStatus = true;
        })
        .catch((error) => {
          console.log(error);
        });
      // Renders, Panoramas, Floorplans type
    } else {
      BunnyNetService.getRenders(this.folderStructure, this.assetType).then(
        (response) => {
          let j = 0;
          // Remap array
          const menuItems = response.data.map((item) => {
            return {
              Guid: item.Guid,
              ObjectName: unslugify(item.ObjectName),
              LinkName: item.ObjectName,
              Path: item.Path,
              IsDirectory: item.IsDirectory,
              StorageZoneName: item.StorageZoneName,
              title: "",
              url: "",
              id: j++,
            };
          });
          this.assetTypes = menuItems;
        }
      );
    }
  },
  methods: {
    reorder: function (data_array, real_order) {
      var i,
        d = {},
        result = [];
      for (i = 0; i < data_array.length; ++i) {
        d[data_array[i].id] = data_array[i];
      }

      for (i = 0; i < real_order.length; ++i) {
        result.push(d[real_order[i]]);
      }

      return result;
    },
  },
  setup() {
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
